import React from "react";

const RefreshIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.32727 6.70857C4.04138 3.85093 6.93686 2.11325 9.7945 2.82736C11.2544 3.19218 12.4223 4.12602 13.1204 5.33492H11.1682C10.8 5.33492 10.5015 5.63339 10.5015 6.00158C10.5015 6.36977 10.8 6.66825 11.1682 6.66825H14.5015C14.6783 6.66825 14.8479 6.59801 14.9729 6.47299C15.0979 6.34796 15.1682 6.17839 15.1682 6.00158V2.66825C15.1682 2.30006 14.8697 2.00158 14.5015 2.00158C14.1333 2.00158 13.8348 2.30006 13.8348 2.66825V4.00138C12.9485 2.81831 11.6645 1.92032 10.1178 1.5338C6.5457 0.641166 2.92635 2.81327 2.03372 6.38532C1.14108 9.95738 3.31318 13.5767 6.88524 14.4694C10.4573 15.362 14.0766 13.1899 14.9693 9.61784C15.0421 9.3264 15.0946 9.03432 15.1275 8.74315C15.1689 8.37729 14.9058 8.04717 14.5399 8.0058C14.1741 7.96444 13.844 8.22749 13.8026 8.59335C13.7763 8.82623 13.7342 9.06037 13.6757 9.29459C12.9616 12.1522 10.0661 13.8899 7.20849 13.1758C4.35084 12.4617 2.61317 9.56622 3.32727 6.70857Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default RefreshIcon;
